
import * as __star__ from '@ckeditor/ckeditor5-basic-styles/dist/index.js';

const {

AttributeCommand,
Bold,
BoldEditing,
BoldUI,
Code,
CodeEditing,
CodeUI,
Italic,
ItalicEditing,
ItalicUI,
Strikethrough,
StrikethroughEditing,
StrikethroughUI,
Subscript,
SubscriptEditing,
SubscriptUI,
Superscript,
SuperscriptEditing,
SuperscriptUI,
Underline,
UnderlineEditing,
UnderlineUI,
_getBasicStylesButtonCreator,
__esModule
} = __star__;

export {
AttributeCommand,
Bold,
BoldEditing,
BoldUI,
Code,
CodeEditing,
CodeUI,
Italic,
ItalicEditing,
ItalicUI,
Strikethrough,
StrikethroughEditing,
StrikethroughUI,
Subscript,
SubscriptEditing,
SubscriptUI,
Superscript,
SuperscriptEditing,
SuperscriptUI,
Underline,
UnderlineEditing,
UnderlineUI,
_getBasicStylesButtonCreator,
__esModule
};

